import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SignalTranslationView from './SignalTranslationView';
import { getSignalTranslation, getUserProfileWidget, getCurrentTimezone, getSelectedDevice } from '../../selectors/index';
import {
  describeSignalTranslationThunk,
  saveSignalTranslationCommentThunk,
  saveSignalTranslationThunk,
  deleteSignalTranslationThunk,
  updateUnitShadowThunk
} from '../../actions/signalTranslation';

const mapStateToProps = state => {
  return {
    signalTranslationManager: getSignalTranslation(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    selectedUnit: getSelectedDevice(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      describeSignalTranslation: (signalTranslationId, unitSerialNumber) =>
        describeSignalTranslationThunk(signalTranslationId, unitSerialNumber, 'SIGNALTRANSLATION_VIEW'),
      saveSignalTranslation: (signalTranslation, unitSerialNumber, isOpSuccessful, widgetCode) =>
        saveSignalTranslationThunk(signalTranslation, unitSerialNumber, isOpSuccessful, widgetCode),
      deleteSignalTranslation: (signalTranslationId, unitSerialNumber, isOpSuccessful) =>
        deleteSignalTranslationThunk(signalTranslationId, unitSerialNumber, isOpSuccessful, 'SIGNALTRANSLATIONDELETE'),
      saveSignalTranslationComment: (signalTranslation, unitSerialNumber, widgetCode) =>
        saveSignalTranslationCommentThunk(signalTranslation, unitSerialNumber, widgetCode),
      updateUnitShadow: (signalTranslation, unitSerialNumber, shadowData, isOpSuccessful) =>
        updateUnitShadowThunk(signalTranslation, unitSerialNumber, shadowData, isOpSuccessful, 'UPLOAD_UNIT_SHADOW')
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignalTranslationView);
